declare var __webpack_public_path__;

/**
 * This will ensure that webpack loads imported parts from the origin server.
 * It does so by retrieving the origin URL from the script tag that loaded the main
 * javascript. It then sets __webpack_public_path__ to point to the folder on the origin
 * server that the main javascript was loaded from.
 * 
 * Example:
 * If the main script was loaded from https://components.xena.biz/en/webcomponents.js then 
 * __webpack_public_path__ will be set to https://components.xena.biz/en/.
 */

const url = new URL((document.currentScript as HTMLScriptElement).src);
const urlString = url.toString();

const originPath = urlString.substr(0, urlString.lastIndexOf('/'));
__webpack_public_path__ = (`${originPath}/${__webpack_public_path__}`);
